// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tcgfronnpkanfgpqeuep.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRjZ2Zyb25ucGthbmZncHFldWVwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA2NjI5OTUsImV4cCI6MjA4NjIzODk5NX0.xeHjRN-Xk6fv8hNHdvEHkF_2vwC07ede5JTkEPMw6Yc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});